// @flow
import { useContext } from 'react';
import { useMutation, MutationOptions } from 'react-query';
import { AppContext } from 'contexts/AppContext';
import { updateApplication } from 'services/applicationService';
import useUserProfileQuery from 'hooks/queries/useUserProfileQuery';

const useUpdateApplicationMutation = ({
  options = {},
}: {
  options: MutationOptions,
} = {}) => {
  const { organizationId, propertyId } = useContext(AppContext);
  const { refetch } = useUserProfileQuery();
  return useMutation(
    async (application) => {
      const {
        data: { applicationId },
      } = await refetch();

      await updateApplication({
        organizationId,
        propertyId,
        applicationId,
        application: { id: applicationId, ...application },
      });
    },
    { ...options, enabled: Boolean(organizationId && propertyId) },
  );
};

export default useUpdateApplicationMutation;
